var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/20px/notifications"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 17C7 18.1047 8.11917 19 9.5 19C10.8808 19 12 18.1047 12 17H7Z",
    fill: "url(#paint0_linear_9146_78896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.75 9.74071V8.67278C14.75 5.69144 12.5352 3.09201 9.66125 3.00256C6.68825 2.90922 4.25 5.3811 4.25 8.44411V9.74071C4.25 10.9191 3.88175 12.0648 3.2 13.0075L2.3375 14.1999C2.1185 14.5025 2 14.8711 2 15.2499C2 16.2167 2.75525 17 3.6875 17H15.3125C16.2448 17 17 16.2167 17 15.2499C17 14.8711 16.8815 14.5025 16.6625 14.1999L15.8 13.0075C15.1182 12.0648 14.75 10.9183 14.75 9.74071Z",
    fill: "url(#paint1_linear_9146_78896)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 14.5,
    cy: 4.5,
    r: 3.5,
    fill: "url(#paint2_linear_9146_78896)",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_78896",
    x1: 4.26667,
    y1: 17.3536,
    x2: 6.38247,
    y2: 21.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9146_78896",
    x1: -6.2,
    y1: 5.47514,
    x2: 12.815,
    y2: 22.6413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9146_78896",
    x1: 9.26667,
    y1: 2.88398,
    x2: 15.9944,
    y2: 8.55264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.39a6649420d3af61975e29512bb6b06f.svg";
export { ForwardRef as ReactComponent };